import type { CustomerExistingValuation as ExistingValuation } from '@einwert/valuation-api-client'
import { getFormattedValueAndUnitFromAreaValue, getFormattedValueAndUnitFromMonetaryValue, MetricGrid, tokens } from 'ComponentLibrary'
import { getFormattedValueAndUnitFromWault } from 'ComponentLibrary/src/common/wault'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type IncomeApproachMetricGridProps = {
    valuation: ExistingValuation
}

export default function IncomeApproachMetricGrid({ valuation }: IncomeApproachMetricGridProps) {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const locale = useCurrentResolvedLocale()
    const values = [
        { ...getFormattedValueAndUnitFromMonetaryValue(valuation.market_value, locale), subheadline: tCommon('marketValue') },
        {
            ...getFormattedValueAndUnitFromMonetaryValue(valuation.tenant_summary?.total?.gross_rental_income.total, locale),
            subheadline: tCommon('marketRent'),
        },
        { ...getFormattedValueAndUnitFromAreaValue(valuation.rentable_area, locale), subheadline: tCommon('rentableArea') },
        {
            ...getFormattedValueAndUnitFromMonetaryValue(valuation.market_value_per_rentable_area, locale),
            subheadline: tCommon('valuePerSquareMeter'),
        },
        {
            ...getFormattedValueAndUnitFromMonetaryValue(valuation.tenant_summary?.total?.actual_rental_income.total, locale),
            subheadline: tCommon('contractRent'),
        },
        {
            ...getFormattedValueAndUnitFromWault(
                valuation.wault,
                {
                    unknown: tCommon('unknown'),
                    unlimited: tCommon('unlimited'),
                    year: tCommon('year'),
                    years: tCommon('years'),
                },
                locale
            ),
            color: valuation.wault === undefined ? tokens.ColorTextSubtlest : undefined,
            subheadline: tCommon('wault'),
        },
    ]

    return <MetricGrid numColumns={3} values={values} variant="spacious" />
}
